// src/components/PreloadFetch.jsx
import React from "react";
import Preload from "./../ripple.svg";

const PreloadFetch = ({ className = "", Loading = true }) => {
    if (!Loading) return null;

    return (
        <div className={`mainPreload mainPreload2 ${className}`.trim()}>
            <img className="preloadFetch" src={Preload} alt="Preload svg" />
        </div>
    );
};

export default PreloadFetch;
